import { patchDismissNotification } from "../../../services/notifications/patchDismissNotification";
import { WSServiceError } from "../../../utils/serviceHelper";
import { useWSMutation, WSMutationConfig, WSQueryCache } from "../../helpers";
import { QUERY_NOTIFICATIONS_NOTIFICATIONS } from "../keys";
import { WSNotificationResponse } from "../../../modules/Dashboard/components/Notifications";

export const useMutationDismissNotification = (
  config?: WSMutationConfig<WSNotificationResponse, WSServiceError, string>
) =>
  useWSMutation((id: string) => {
    // Optimistic update
    WSQueryCache.setQueryData(QUERY_NOTIFICATIONS_NOTIFICATIONS, () => {
      return WSQueryCache.getQueryData<WSNotificationResponse[]>(
        QUERY_NOTIFICATIONS_NOTIFICATIONS
      )?.filter(notificaiton => notificaiton.channelMessageId !== id);
    });

    return patchDismissNotification(id);
  }, config);
